<template>
  <div>
    <!-- Page Title -->
    <page-title
      icon="fa fa-solid fa-clipboard"
      main="Avaliações"
      :sub="avaliation.name"
      :help="true"
      titleHelp="Página responsável pela listagem e gerenciamento das avaliações 360."
      content="Para alteração basta ir com o mouse em ações e clicar em Editar. Para criação pressione o botão no canto superior direito 'Nova Avaliação'"
    />

    <!-- Dashboards -->
    <avaliation-item-dashboard
      :avaliation-items="avaliationItems"
      :avaliation="avaliation"
      :loading="loading.dashboard"
    />

    <!-- Avaliation Response List -->
    <div class="card mt-2" style="padding: 1rem">
      <div class="border-0 card-header">
        <h3 class="mb-0">Resultados da Avaliação</h3>
        <h5>{{ avaliation.name }}</h5>
      </div>

      <avaliation-item-results-list
        :avaliation-item-responses="avaliationItemResponses"
        :avaliation-items="avaliationItems"
        :loading="loading.responses"
      />

      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          @input="getAvaliationItemResponses"
          v-model="pagination.page"
          :total="pagination.count"
          :perPage="pagination.per_page"
        >
        </base-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import AvaliationItemResultsList from "../../components/Avaliation/AvaliationItemResultsList.vue";
import AvaliationList from "@/components/Avaliation/AvaliationList.vue";
import AvaliationItemDashboard from "../../components/Avaliation/AvaliationItemDashboard.vue";

export default {
  name: 'ListAvaliations',
  components: {
    PageTitle,
    AvaliationList,
    AvaliationItemResultsList,
    AvaliationItemDashboard,
  },
  data: () => ({
    avaliation: {},
    avaliationItems: [],
    avaliationItemResponses: [],
    lastRequest: 1,
    lastAvaliationResponseRequest: 1,
    loading: {
      avaliation: false,
      responses: false,
      dashboard: false,
    },
    pagination: {
      page: 1,
      per_page: 10,
      count: 0,
    },
  }),
  mounted() {
    this.getAvaliation();
    this.getAvaliationItems();
    this.getAvaliationItemResponses();
  },
  methods: {
    async getAvaliation() {
      console.log("[ListAvaliations][getAvaliation] Getting avaliation #id", this.avaliationId)
      this.loading.avaliation = true;

      try {
        const response = await this.$http.secured.get(`/api/v1/avaliations/${this.avaliationId}`);
        this.avaliation = response.data;
      } catch (error) {
        this.$store.dispatch('snackbar/showError', error);
      }
      this.loading.avaliations = false;
    },
    async getAvaliationItemResponses() {
      console.log("[ListAvaliations][getAvaliationItemResponses] Getting avaliation item responses, page ", this.pagination.page)
      this.loading.avaliations = true;
      const currentAvaliationResponseRequest = ++this.lastAvaliationResponseRequest;

      try {
        const response = await this.$http.secured.get(`/api/v1/avaliations/${this.avaliationId}/avaliation_item_responses`, {
          params: {
            page: this.pagination.page,
            per_page: this.pagination.per_page,
          },
        });

        if (currentAvaliationResponseRequest !== this.lastAvaliationResponseRequest) return;

        this.avaliationItemResponses = response.data.data;
        this.pagination.page         = response.data.page     || 1;
        this.pagination.per_page     = response.data.per_page || 10;
        this.pagination.count        = response.data.count    || 0;

        this.lastAvaliationResponseRequest = currentAvaliationResponseRequest;
      } catch (error) {
        this.$store.dispatch('snackbar/showError', error);
      }
      this.loading.avaliations = false;
    },
    async getAvaliationItems() {
      console.log("[ListAvaliations][getAvaliationItems] Getting avaliation item responses, page ", this.pagination.page)
      try {
        const response = await this.$http.secured.get(`/api/v1/avaliations/${this.avaliationId}/avaliation_items`, {
          params: { page: 1, per_page: 900, }
        });

        this.avaliationItems = response.data.avaliation_items;
      } catch (error) {
        this.$store.dispatch('snackbar/showError', error);
      }
    },
  },
  computed: {
    avaliationId() {
      return this.$route.params.avaliationId;
    },
  },
}
</script>
